import { lazy } from 'react';
import { Route, Routes, useLocation } from 'react-router';
import NotFound from '@/components/blocks/NotFound';
import CenteredLayout from '@/components/layouts/CenteredLayout';
import InvitationPage from '@/pages/InvitationPage';
import LoginPage from '@/pages/LoginPage';
import MSALCallback from '@/pages/LoginPage/MSAL/MSALCallback';
import OIDCCallback from '@/pages/LoginPage/OIDC/OIDCCallback';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import RedirectTo from '@/RedirectTo';

const DemoRegistrationPage = lazy(() => import('@/pages/DemoRegistrationPage'));
const DemoWelcomePage = lazy(() => import('@/pages/DemoRegistrationPage/DemoWelcomePage'));

const UnauthenticatedRoutes = () => {
    const location = useLocation();

    const invitationRoute = (
        <Route element={<CenteredLayout />} path="/invitation/*">
            <Route element={<InvitationPage />} index />
            <Route element={<NotFound homePath="/invitation/" />} path="*" />
        </Route>
    );

    return (
        <Routes>
            {invitationRoute}
            <Route element={<RedirectTo to="/login/" />} path="/signout" />
            <Route element={<CenteredLayout />} path="/login/*">
                <Route element={<LoginPage />} index />
                <Route element={<ResetPasswordPage />} path="resetPassword" />
                <Route element={<MSALCallback />} path="sso/msal" />
                <Route element={<OIDCCallback />} path="sso/oidc" />
                <Route element={<NotFound homePath="/login/" />} path="*" />
            </Route>
            <Route element={<DemoWelcomePage />} path="/demo/:companyId" />
            <Route element={<DemoRegistrationPage />} path="/demo/:companyId/register" />
            <Route
                element={<RedirectTo state={{ from: location.pathname, fromState: location.state }} to="/login/" />}
                path="*"
            />
        </Routes>
    );
};

export default UnauthenticatedRoutes;
